import type { Direction, GameState } from '@neon-maw/shared';

declare global {
  interface Window {
    __NEON_MAW_DEBUG__?: {
      getState: () => GameState;
      step: (dir: Direction) => GameState;
    }
  }
}

export function installDebugApi(getState: () => GameState, step: (dir: Direction) => void): void {
  if (import.meta.env.DEV) {
    window.__NEON_MAW_DEBUG__ = {
      getState,
      step: (dir: Direction) => { step(dir); return getState(); }
    };
  }
}
